import { render, staticRenderFns } from "./TableSSR.vue?vue&type=template&id=4b49412a"
import script from "./TableSSR.vue?vue&type=script&lang=js"
export * from "./TableSSR.vue?vue&type=script&lang=js"
import style0 from "./TableSSR.vue?vue&type=style&index=0&id=4b49412a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports